import { render, staticRenderFns } from "./ieltsHistory.vue?vue&type=template&id=3772d6d0&scoped=true&"
import script from "./ieltsHistory.vue?vue&type=script&lang=js&"
export * from "./ieltsHistory.vue?vue&type=script&lang=js&"
import style0 from "./ieltsHistory.vue?vue&type=style&index=0&id=3772d6d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3772d6d0",
  null
  
)

export default component.exports